import { createContext } from "react";

export const AttendanceContext = createContext();
